/**
 * Branding configuration for different domains
 */

export interface BrandingConfig {
  name: string;
  shortName: string;
  domain: string;
  contactEmail: string;
  coachEmail: string;
  supportEmail: string;
  calendlyBase: string;
  coachingTeamName: string;
  websiteUrl: string;
  hipaaUrl: string;
  privacyUrl: string;
  webinarsUrl: string | null;
  address: {
    street: string;
    city: string;
    state: string;
    zip: string;
  };
  legalEntity: string;
}

export const HEALTHJOY_CONFIG: BrandingConfig = {
  name: "HealthJoy MSK",
  shortName: "HealthJoy",
  domain: "msk.healthjoy.com",
  contactEmail: "support@healthjoy.com",
  coachEmail: "coach@healthjoy.com",
  supportEmail: "support@healthjoy.com",
  calendlyBase: "healthjoy-msk-coaches",
  coachingTeamName: "HealthJoy Coaching Team",
  websiteUrl: "https://www.healthjoy.com",
  hipaaUrl: "https://www.healthjoy.com/hipaa",
  privacyUrl: "https://www.healthjoy.com/privacy-policy",
  webinarsUrl: "https://www.healthjoy.com/msk-webinars-library",
  address: {
    street: "435 North LaSalle Drive, Suite 400",
    city: "Chicago",
    state: "IL",
    zip: "60654",
  },
  legalEntity: "HealthJoy, LLC",
};

const BRAINBODY_CONFIG: BrandingConfig = {
  name: "Brain Body MSK",
  shortName: "Brain Body",
  domain: "brainbodymsk.com",
  contactEmail: "support@brainbodymsk.com",
  coachEmail: "coach@brainbodymsk.com",
  supportEmail: "support@brainbodymsk.com",
  calendlyBase: "brainbodymsk-coaches",
  coachingTeamName: "BrainBodyMSK Coaching Team",
  websiteUrl: "https://brainbodymsk.com",
  hipaaUrl: "https://brainbodymsk.com/hipaa",
  privacyUrl: "https://brainbodymsk.com/privacy-policy",
  webinarsUrl: null, 
  address: {
    street: "TBD", 
    city: "TBD",
    state: "TBD",
    zip: "TBD",
  },
  legalEntity: "Brain Body MSK, LLC",
};

/**
 * Determines if the current domain is Brain Body MSK
 */
export const isBrainBodyMSK = (): boolean => {
  return window.location.hostname.includes("brainbodymsk.com");
};

/**
 * Returns the current branding configuration based on the domain
 */
export const getBrandingConfig = (): BrandingConfig => {
  return isBrainBodyMSK() ? BRAINBODY_CONFIG : HEALTHJOY_CONFIG;
};

/**
 * Returns the appropriate logo path based on the current domain
 * @deprecated Use getLogoPath from logoHelper instead
 */
export const getLogoPath = (): string => {
  return isBrainBodyMSK() ? "/images/BrainBodyMSKLogo.svg" : "/images/logo.svg";
};
